import React from 'react';
import Table from '../../components/common/Table';
import { FirearmActionDTO } from '../../services/apiClient';
import { renderBooleanBadge } from '../../utils/displayUtils';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface FirearmActionTableProps {
  data: FirearmActionDTO[];
  handleEdit: (row: FirearmActionDTO) => void;
  handleDelete: (row: FirearmActionDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const FirearmActionTable: React.FC<FirearmActionTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: FirearmActionDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Position',
          key: 'displayPosition',
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (createdUtc: Date) =>
            convertToUserTime(createdUtc?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default FirearmActionTable;
